import {SET_AI_READING} from '../actions/types';


const aiReading = (state = null, action) => {
  switch (action.type) {
    case SET_AI_READING:
      return action.payload;
    default:
      return state;
  }
};

export default aiReading;